module.exports = {"411081001":"颍川街道","411081002":"夏都街道","411081003":"韩城街道","411081004":"钧台街道","411081005":"褚河街道","411081100":"火龙镇","411081101":"顺店镇","411081102":"方山镇","411081103":"神垕镇","411081104":"鸿畅镇","411081105":"梁北镇","411081106":"古城镇","411081107":"无梁镇","411081108":"文殊镇","411081109":"鸠山镇","411081111":"范坡镇","411081112":"郭连镇","411081113":"朱阁镇","411081114":"浅井镇","411081115":"方岗镇","411081116":"花石镇","411081117":"张得镇","411081118":"苌庄镇","411081119":"小吕镇","411081204":"磨街乡","411081210":"山货回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411081.json
// module id = 1744
// module chunks = 0